import React from "react";
import { Form } from "react-bootstrap";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Orange_btn from "../../../../../../common_components/common_btn/orange_btn/Orange_btn";

function Step2({ onNext, onBack }) {
  return (
    <div className="mt-4 card_box">
      <div className="heading_text_holder">
        <h1>Complete: 'If I _____ rich, I would travel everywhere.'</h1>
      </div>

      <Form className="mt-3 lt_options">
        <Form.Group className="mb-3">
          <Form.Check type="radio" name="q2" label="Were" className="lt_option" />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check type="radio" name="q2" label="Am" className="lt_option" />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check type="radio" name="q2" label="Will be" className="lt_option" />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Check type="radio" name="q2" label="Would be" className="lt_option" />
        </Form.Group>
      </Form>

      <div className="btn_holder">
      <Orange_btn btn_text="Back" onClick={onBack} />
        <Blue_btn btn_text="Next" onClick={onNext} />
      </div>
    </div>
  );
}

export default Step2;
